import { render, staticRenderFns } from "./KeyboardEvents.vue?vue&type=template&id=0ce15dfa&scoped=true"
import script from "./KeyboardEvents.vue?vue&type=script&lang=js"
export * from "./KeyboardEvents.vue?vue&type=script&lang=js"
import style0 from "./KeyboardEvents.vue?vue&type=style&index=0&id=0ce15dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce15dfa",
  null
  
)

export default component.exports